module.exports = __webpack_public_path__ + "img/35_38.3cdcbb0d.png";